export default "__VITE_ASSET__B0UJdH1g__"